import { APP_URL, SLACK_CLIENT_ID } from 'constants/ResourcesConstants'
import { makeOauthUrl } from 'components/Integration/components/OauthConnector'
import Template from './Template'
// import { captureException, captureResponseException } from 'utils/SentryHelpers'

var SLACK_OAUTH_PAYLOAD = {
  client_id: SLACK_CLIENT_ID,
  scope: "bot,incoming-webhook,channels:read,channels:write,users:read,commands,groups:write,groups:read",
  response_type: 'code',
  redirect_uri: `${APP_URL}/accept-integration/slack`,
  state: ''
}
const SLACK_AUTH_URL = 'https://slack.com/oauth/authorize'

const CONNECT_COPY = [
  "Did you know you can talk to your customers on the go right from",
  <img style={{ width: 61, height: 18, marginLeft: 5, marginRight: 5, verticalAlign: "middle" }} src={ require('images/svg/slack-logo-with-name.svg') } />,
  "?"
]

const ConnectButton = (
  <button
    className="dsg-LargeButton color-teal"
    onClick={ () => {
      const path = makeOauthUrl(SLACK_AUTH_URL, SLACK_OAUTH_PAYLOAD)
      window.location.href = path
    }}
  >
    CONNECT TO SLACK
  </button>
)

const mailToHref = "mailto:?subject=Drift%20%3C%3E%20Slack&body=Hey!%20Do%20you%20mind%20helping%20me%20integrate%20Drift%20with%20our%20Slack%20account%20so%20we%20can%20talk%20to%20customers%20on%20the%20go?"
const ContactTeam = (
  <a style={{ marginTop: 20, textDecoration: "underline" }} href={ mailToHref } className="color-gray-dark">
    Or ask a technical co-worker to
  </a>
)

const ConnectedToSlack = (
  <Template
    title="Looks like you’re on a mobile device."
    copy={ CONNECT_COPY }
    button={ [ConnectButton, ContactTeam] }
  />
)

export default ConnectedToSlack



// WEBPACK FOOTER //
// ./src/scripts/components/MobileLander/ConnectToSlack.js